import { render, staticRenderFns } from "./coolButton.vue?vue&type=template&id=e4f16726&scoped=true&"
import script from "./coolButton.vue?vue&type=script&lang=js&"
export * from "./coolButton.vue?vue&type=script&lang=js&"
import style0 from "./coolButton.vue?vue&type=style&index=0&id=e4f16726&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f16726",
  null
  
)

export default component.exports